export const ROLES = {
  ADMIN: "admin",
  BROKER: "broker",
  USER: "user",
} as const;
